import { render, staticRenderFns } from "./default.vue?vue&type=template&id=6368b3c7&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutHeader: require('/var/www/front/components/layout/header.vue').default,LayoutFooter: require('/var/www/front/components/layout/footer.vue').default})
